import { Component, Input, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-check-form-answers',
  templateUrl: './check-form-answers.component.html',
  styleUrls: ['./check-form-answers.component.scss'],
})
export class CheckFormAnswersComponent implements OnInit {
  @Input() userId!: number;

  forms: any;
  selectedForms: any[] = [];

  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.getUserCheckForms();
  }

  getUserCheckForms() {
    this.userService
      .getUserForm(this.userId, 'FIRST_CHECK_METRICS')
      .subscribe((forms: any) => {
        this.forms = forms.forms.filter((form: any) => {
          form.responses.forEach((response: any) => {
            if (
              !isNaN(parseInt(response.answer)) &&
              isFinite(response.answer)
            ) {
              response.answer = parseInt(response.answer);
              response.type = 'NUMBER';
            }
          });
          const completedAt = dayjs(form.completed_at);
          if (completedAt.year() === 0 || !completedAt.year()) {
            delete form['completed_at'];
          }

          return form;
        });
      });
  }

  toggleFormSelection(form: any) {
    const index = this.selectedForms.indexOf(form);
    if (index > -1) {
      this.selectedForms.splice(index, 1);
    } else if (this.selectedForms.length < 2) {
      this.selectedForms.push(form);
      if (this.selectedForms.length === 2) {
        this.compareForms();
      }
    }
  }

  compareForms() {
    if (this.selectedForms.length === 2) {
      // Logic to compare forms
    }
  }

  get longerForm() {
    return this.selectedForms[0].responses.length >
      this.selectedForms[1].responses.length
      ? this.selectedForms[0]
      : this.selectedForms[1];
  }
}
